<template>
    <div class="todo-table table-list">
        <div class="table-list-title">
            <span class="category">分類</span>
            <span class="description">待辦敘述</span>
        </div>
        <div class="table-list-body">
            <div v-show="list.length == 0" class="is-empty">0 筆資料</div>
            <ul>
                <li v-for="(item, index) in loopLimit" :key="index" @click="$router.push({name: 'bizHouseMgtDefault', query: {complete: '0'}})">
                    <span class="category">{{transTodoListCat(item.category)}}</span>
                    <span v-if="item.category == 'INCOMPLETE'" class="description">還有{{item.incompleteCount}}間房源未完善</span>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { apiBizGetTodoListHouse } from "@/apis/api.js";

export default {
    data () {
        return {
            list: ''
        }
    },
    mounted () {
        this.getTodoListHouse()
    },
    props: {
        limit: false
    },
    watch: {
        filterQuery: {
            handler: function () {
                this.getTodoListHouse()
            },
            deep: true
        }
    },
    methods: {
        getTodoListHouse : function () {
            let data = {
                county: this.filterQuery.county,
                district: this.filterQuery.district,
                groupId: this.filterQuery.groupId,
                memberId: this.filterQuery.memberId
            }
            apiBizGetTodoListHouse(data)
            .then(res => {
                console.log(res)
                if( res.data.status == 'SUCCESS'){
                    this.list = res.data.result
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
    },
    computed: {
        loopLimit: function () {
            if(this.limit){
                return this.list.slice(0, this.limit)
            }else{
                return this.list
            }
        },
        ...mapGetters({
            filterQuery: 'BIZ_TODO_LIST_FILTER_QUERY',
        })
    }
}
</script>
<style lang="scss" scoped>
    .todo-table{
        &.table-list{
            width: 100%;
            border-radius: 0;
            border-left: none;
            border-right: none;
            border-bottom: none;
            box-sizing: border-box;
            .table-list-body ul li{
                align-items: flex-start;
                cursor: pointer;
            }
        }
        .category{
            width: 76px;
            margin-right: 60px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/bussiness/personalHome/home/todoList/todoHouse.vue